import { render } from "./GiftDeposit.vue?vue&type=template&id=5a93ede9&scoped=true"
import script from "./GiftDeposit.vue?vue&type=script&lang=js"
export * from "./GiftDeposit.vue?vue&type=script&lang=js"

import "./GiftDeposit.vue?vue&type=style&index=0&id=5a93ede9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a93ede9"]])

export default __exports__